import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackdropService } from './backdrop.service';

@Component({
    selector: 'app-backdrop',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './backdrop.component.html',
    styleUrl: './backdrop.component.scss'
})
export class BackdropComponent {
    private backdropService = inject(BackdropService);



    // Computed signals per la reattività
    isVisible = computed(() => this.backdropService.isActive());
    loadingText = computed(() => this.backdropService.loadingText());
    loadingSpinner = computed(() => this.backdropService.loadingSpinner());

    /**
     * Gestisce il click sul backdrop
     * Puoi personalizzare questo comportamento
     */
    onBackdropClick(event: MouseEvent): void {
        // Previeni la chiusura se clicchi sul contenuto
        if ((event.target as HTMLElement).classList.contains('backdrop-container')) {
            // Opzionale: puoi decidere se chiudere il backdrop al click
            this.backdropService.hide();
        }
    }
}